<div class="grid-x grid-margin-x">
  @if (wellList != null) {
    <div class="cell small-12 medium-12 large-12">
      Select @if (selectionMode === modes.Multiple) {
      one or more wells
    } @else {
      one well
      } from the list below you are reporting {{reportType?.description}} for. <br />
    </div>
    <div class="cell small-12 medium-12 large-12">
      <span class="bold minor-margin-right">What if I don't see my API #?</span><help-text [helpText]="wheresMyAPIText"></help-text>
    </div>
  } @else {
    <div class="cell small-9 medium-8 large-8">
      The selected report type requires @if (selectionMode === modes.Multiple) {
      at least one well
    } @else {
      one well
      } for submission.
    </div>
    <div class="cell small-3 medium-4 large-4">
      <button class="button" (click)="findWells()" [disabled]="searchingWells">Search for Wells</button>
    </div>
    @if (reportTypeChanged) {
      <div class="cell small-12 medium-12 large-12 margin-bottom">
        <span class="red bold italic">Due to a change in report type, a new search for wells must be performed.</span>
      </div>
    }
  }

  <div class="cell small-12 medium-12 large-12">
    <text-loader [run]="searchingWells" [text]="'Loading Wells'" [tickType]="'.'" [interval]="1500"></text-loader>
    @if (!searchingWells && wellList != null) {
      <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="wellList" [rowSelection]="rowSelection" [selectionColumnDef]="selectionColumnDef" (selectionChanged)="onGridSelecting($event)" aria-label="Well Selector"></ag-grid-angular>
    }

  </div>
</div>




